import NavBar from "../components/NavBar";
import styles from "../styling/loadPage.module.css";
import { useState, useEffect } from "react";

function LoadPage() {
  const [displayedText, setDisplayedText] = useState("");
  const [currentStep, setCurrentStep] = useState(0);

  const steps = [
    "Reading through student profiles...",
    "Understanding your search intent...",
    "Matching skills and experiences...",
    "Ranking the best matches...",
  ];

  useEffect(() => {
    const text = steps[currentStep];
    let index = 0;

    const typingInterval = setInterval(() => {
      if (index < text.length) {
        setDisplayedText(text.substring(0, index + 1));
        index += 2;
      } else {
        clearInterval(typingInterval);
        setTimeout(() => {
          setCurrentStep((prev) => (prev + 1) % steps.length);
        }, 1500);
      }
    }, 15);

    return () => clearInterval(typingInterval);
  }, [currentStep]);

  return (
    <>
      <NavBar />
      <div className={styles.container}>
        <div className={styles.content}>
          <div className={styles.loadingWrapper}>
            <div className={styles.sparkles}>
              <div className={styles.sparkle}></div>
              <div className={styles.sparkle}></div>
              <div className={styles.sparkle}></div>
            </div>
            <div className={styles.textContent}>
              <div className={styles.status}>
                <span>Hatch AI</span>
                <span className={styles.dots}>...</span>
              </div>
              <p className={styles.stepText}>{displayedText}</p>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default LoadPage;
